import api from './api';

export const loginUser = async (credentials) => {
  const response = await api.post('/login', credentials);
  return response.data;
};

export const registerUser = async (userData) => {
  const response = await api.post('/register', userData);
  return response.data;
};

export const getUsers = async () => {
  const response = await api.get('/allusers');
  return response.data;
};


export const forgotPassword = async (data) => {
  const response = await api.post('/forgot-password', data);
  return response.data;
};

export const resetPassword = async (data) => {
  const response = await api.post('/reset-password', data);
  return response.data;
};
export const getContent = async (contentType, params = {}) => {
  const response = await api.get(`/content/${contentType}`, { params });
  return response.data;
};

// Add other API calls as needed